import { render, staticRenderFns } from "./noright.vue?vue&type=template&id=843f9d18&"
import script from "./noright.vue?vue&type=script&lang=js&"
export * from "./noright.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports